import React from 'react';
import { IonSpinner } from '@ionic/react';

type PublishingOverlayProps = {
  isLoading: boolean;
  isPublished?: boolean;
};

export function PublishingOverlay({ isLoading, isPublished = false }: PublishingOverlayProps) {
  return (
    <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-background backdrop-blur-lg">
      {isLoading ? (
        <>
          <IonSpinner name="crescent" className="size-10 text-primary" />
          <p className="mt-4 text-sm text-muted-foreground">Publishing...</p>
        </>
      ) : (
        <>
          <div className="size-10 text-green-500 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="size-8"><polyline points="20 6 9 17 4 12"></polyline></svg>
          </div>
          <p className="mt-4 text-sm font-medium text-green-500">Published!</p>
        </>
      )}
    </div>
  );
}
